import React, { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import api from '../api/axios'
import { Zap, AlertTriangle } from 'lucide-react'

export default function PaymentAddonSuccessPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const orderId = searchParams.get('token')
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')

  useEffect(() => {
    if (!orderId) { setStatus('error'); return }
    api.post('/payment/capture-addon-order', { orderId })
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'))
  }, [orderId])

  return (
    <div style={{ minHeight: '100vh', background: '#0B0F19', fontFamily: 'Poppins, sans-serif', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#1A1F2E', borderRadius: 20, padding: '48px 40px', maxWidth: 480, width: '100%', textAlign: 'center' }}>

        {status === 'loading' && (
          <>
            <div style={{ width: 60, height: 60, border: '4px solid #FF7F32', borderTopColor: 'transparent', borderRadius: '50%', margin: '0 auto 24px', animation: 'spin 1s linear infinite' }} />
            <p style={{ color: '#9CA3AF', fontSize: 16 }}>Activating your revision add-on...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ width: 72, height: 72, background: 'rgba(168,85,247,0.15)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', fontSize: 36 }}>
              <Zap className="w-12 h-12 text-orange-500" />
            </div>
            <h1 style={{ color: '#fff', fontSize: 26, fontWeight: 700, marginBottom: 12 }}>
              Revision Add-on Activated!
            </h1>
            <p style={{ color: '#9CA3AF', fontSize: 14, lineHeight: 1.6, marginBottom: 28 }}>
              You now have <strong style={{ color: '#fff' }}>unlimited revisions</strong> for the rest of your current subscription period.
              A confirmation has been sent to your email.
            </p>
            <button
              onClick={() => navigate('/billing')}
              style={{ background: '#FF7F32', color: '#fff', fontWeight: 700, fontSize: 15, padding: '14px 32px', borderRadius: 10, border: 'none', cursor: 'pointer' }}>
              Back to Billing
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ marginBottom: 24 }}><AlertTriangle size={48} className="text-yellow-500" /></div>
            <h1 style={{ color: '#fff', fontSize: 22, fontWeight: 700, marginBottom: 12 }}>Something went wrong</h1>
            <p style={{ color: '#9CA3AF', fontSize: 14, lineHeight: 1.6, marginBottom: 24 }}>
              Your payment may have been processed but we couldn't activate the add-on automatically.
              Please contact us and we'll sort it out immediately.
            </p>
            <a href="https://subscribe.inkcrediblestudios.com#contact"
              style={{ background: '#FF7F32', color: '#fff', fontWeight: 700, fontSize: 14, padding: '12px 28px', borderRadius: 10, textDecoration: 'none', display: 'inline-block' }}>
              Contact Support
            </a>
          </>
        )}
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )
}